<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Organization design",
    "pageDesc":"Designing your organization and implementing a new startcure to boost your enterprise performance and accelerate your growth.",
    "mantra":"Designing your |organization.",
    "sec1Items":{
      "1":{
        "title":"Organization Structure",
        "desc":"Plan the perfect team size and span of control for your business and know your information flows."
      },
      "2":{
        "title":"Company Culture",
        "desc":"Outline your company most important values and principles and document it for your clients, partners and internal employees."
      },
      "3":{
        "title":"Documentation and Setup",
        "desc":"Ensure that everyone is aware of the policies and production procedures through inclusive documentation. "
      }
    },
    "sec2":"Boost your organization's health.",
    "sec2Items":{
      "1":{
        "title":"Performance acceleration",
        "desc":"Keeping your organizational agility at the core and enhancing both your business performance and employee engagement."
      },
      "2":{
        "title":"Strategy alignment",
        "desc":"Ensuring the alignment between your current employment structure, business model and  business operations and driving your management attention  towards the strategic priorities and critical operations of the business."
      },
      "3":{
        "title":"Strategic foundation",
        "desc":"Laying a solid infrastructure by assessing your weaknesses, strengths and aligning your organization design choices to support your business goals."
      },
      "4":{
        "title":"Change management",
        "desc":"Keep up with ever changing markets and discover new opportunities by redesigning your organization to operate effectively."
      },
      "5":{
        "title":"Enterprise efficiency",
        "desc":"Increasing your performance effectiveness by eliminating unnecessary costs, setting clear responsibilities, and planning your infrastructure to be growth driven. "
      },
      "6":{
        "title":"Large scale collaboration",
        "desc":"Going beyond classic organizational charts to design the relationships between humans to enable collaboration and unlock business potentials."
      }
    },

    "cta":"Build a robust <br> organization design."
  },
  "ar": {
    "pageTitle":"تخطيط الشركات والمؤسسات",
    "pageDesc":"قم بتصميم مؤسستك ونفذ هيكل جديد يساعدك على تعزيز أداء مؤسستك بأكملها وواكب تغييرات السوق الخاصة بك وسرع من نموك.",
    "mantra":"تخطيط الشركات |والمؤسسات استراتيجيًا. ",
    "sec1Items":{
      "1":{
        "title":"الهيكل التنظيمى",
        "desc":"ننظم معك طريقة انتقال المعلومات والمهام داخل مكان عملك؛ من أجل إنتاجية أفضل. عن طريق التخطيط المناسب لشكل فريقك والعمليات التي عليه القيام بها."
      },
      "2":{
        "title":"ثقافة الشركة",
        "desc":"نحدد لك القيم والمبادئ التي توضح طريقة عملك، وكذلك شكل التعامل مع موظفيك ومع عملائك و نوثقها لك لتكون دليلاً واضحًا لفهم طبيعة عملك."
      },
      "3":{
        "title":"التوثيق والإعداد",
        "desc":"نعمل معك من أجل التأكد أن جميع من في المؤسسة على دارية بالسياسات التي تضعها وإجراءات الإنتاج من خلال وثائق شاملة."
      }
    },
    "sec2":"حسّن من أداء مؤسستك. ",
    "sec2Items":{
      "1":{
        "title":"تسريع الأداء",
        "desc":"حافظ على رشاقة وتوازن مؤسستك، واعمل على تعزيز أداء عملك التجاري وكذلك كيفية مشاركة الموظفين فيه."
      },
      "2":{
        "title":"محاذاة الاستراتيجية",
        "desc":"اضمن المواءمة بين هيكل التوظيف الحالي ونموذج العمل والعمليات التجارية ودفع انتباه الإدارة نحو الأولويات الاستراتيجية والعمليات الحيوية للشركة."
      },
      "3":{
        "title":"الأساس الاستراتيجي",
        "desc":"ضع بنية أساسية صلبة لعملك من خلال تقييم نقاط الضعف والقوة لديك ومواءمة خيارات تصميم مؤسستك من أجل دعم أهداف عملك."
      },
      "4":{
        "title":"تغيير الإدارة",
        "desc":"واكب الأسواق المتغيرة باستمرار واكتشف فرص جديدة من خلال إعادة تصميم مؤسستك من أجل العمل بفاعلية."
      },
      "5":{
        "title":"كفاءة المؤسسة",
        "desc":"اعمل على زيادة فاعلية أدائك من خلال التخلص من التكاليف الغير ضرورية، وتحديد المسؤوليات بوضوح والتخطيط للبنية الأساسية لنطلق نحو النمو."
      },
      "6":{
        "title":"تعاون واسع النطاق",
        "desc":"تجاوز المخططات التنظيمية الكلاسيكية من أجل تصميم علاقات مميزة بين أفراد المؤسسة وفتح إمكانات متعددة للعمل."
      }
    },
    "cta":"صمم مؤسستك على <br> أساس قوي."
  }
}
</i18n>
